import React from "react";
import { Container, Typography, Card, CardMedia, CardContent, Grid } from "@mui/material";

const careers = [
    {
        id: 1,
        Title: "A Culture of High Performance",
        image: "/Culture_of_High_Performance.png",
        description:
            "Work alongside colleagues who  \n know what it takes to get the job \n done and who go that extra mile to \n  ensure the job is done right the \n first time.",
    },
    {
        id: 2,
        Title: "A Company of Integrity",
        image: "/Company_of_Integrity.png",
        description: "Integrity is woven into the fabric of \n Intrinsic. We put our colleagues first \n and every decision we make is with \n careful consideration of the \n colleague impact."
    },
    {
        id: 3,
        Title: "A Progressive  Environment",
        image: "/Progressive.png",
        description: "From technology to methodology, \n Intrinsic remains on the cutting edge \n of innovation in our industry. "
    },
];


export default function CareersPage() {
    return (
        <Container maxWidth="lg">
            <Typography variant="h4" fontWeight="bold" mb={4} align="center">
                Careers At Intrinsic Clinical Systems
            </Typography>
            <Grid container spacing={3} justifyContent="center" alignItems="stretch">
                {careers.map(({ id, Title, image, description }) => (
                    <Grid key={id} item xs={12} sm={6} md={4} display="flex">
                        <Card
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                flexGrow: 1,  // make card stretch
                                borderRadius: 3,
                                boxShadow: 3,
                            }}
                        >
                            <CardMedia
                                component="img"
                                image={image}
                                alt={Title}
                                sx={{
                                    width: "100%",
                                    height: 220,
                                    objectFit: "cover",
                                }}
                            />

                            <CardContent
                                sx={{
                                    flexGrow: 1,          // fill remaining space
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    textAlign: "center",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    gutterBottom
                                    sx={{
                                        fontFamily: "Montserrat, sans-serif",
                                        minHeight: 60,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {Title}
                                </Typography>
                              
                              <Typography
                                    variant="body1"
                                    sx={{
                                        whiteSpace: "pre-line",
                                        fontFamily: "Montserrat, sans-serif",
                                        lineHeight: 1.6,
                                        flexGrow: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {description}
                                </Typography>
                              
                                
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>


        </Container>
    );
}
